// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3fEye","title":"ClientCherryInfo_title__Qm7NM","itemText":"ClientCherryInfo_itemText__A1-Jx"};